const data = {
    materialType : ['kraft', 'semi', 'agro', 'rg', 'duplex', 'sbs', 'korean kraft', 'star'],
    materialGsm : {
        rg : [80, 100, 120, 140],
        kraft: [140, 180, 230],
        semi: [100, 120, 140, 180],
        agro: [80, 100],
        duplex: [200, 230, 250, 285, 300, 350],
        sbs: [],
        'korean kraft': [180, 200, 230, 250],
        star: []
    },
    materialBf : {
        rg: [16, 18],
        kraft: [18, 20, 22, 24],
        semi: [16, 18, 20, 22],
        agro: [16, 18],
        duplex: [20],
        sbs: [],
        'korean kraft': [],
        star: []
    },
    ff: [1.2, 1.5, 1.7],
    unitType: ["mm", "cm", "inches"],
	ply: [
		{name: "3 ply/ Single Wall", value: 3},
		{name: "5 ply/ Double Wall", value: 5},
		{name: "7 ply/ Triple Wall", value: 7},
		{name: "9 ply/ Quadraple Wall", value: 9}
	],
    castingType: [{name: "Die-Cut", value: "DIE"}, {name: "Rotary-Slot", value: "ROTARY-SLOT"}]
}

export default data